import { notification } from "antd";

const notificationService = {
    success,
    error,
    warning,
    info
};

/**
 * The API returns a validation message as an array of strings, which is what
 * Nest does for a BadRequest. An array is an object, so the object branch
 * below used to read `.message` off one, find undefined, and raise a
 * notification with an empty title: the request had failed and the screen
 * said nothing at all. That is how "a note is required when adding 8" reached
 * the browser and was never shown.
 */
function asText(value) {
    if (Array.isArray(value)) return value.filter(Boolean).join("\n");
    return value || "";
}

// Helper function to normalize arguments (supports both object and string formats)
function normalizeArgs(messageOrObj, description) {
    if (Array.isArray(messageOrObj)) {
        return {
            message: asText(messageOrObj),
            description: asText(description)
        };
    }
    if (typeof messageOrObj === 'object' && messageOrObj !== null) {
        return {
            message: asText(messageOrObj.message),
            description: asText(messageOrObj.description)
        };
    }
    return {
        message: asText(messageOrObj),
        description: asText(description)
    };
}

function success(messageOrObj = "", description = "") {
    const { message, description: desc } = normalizeArgs(messageOrObj, description);
    notification.success({
        message,
        description: desc
    });
}

function error(messageOrObj = "", description = "") {
    const { message, description: desc } = normalizeArgs(messageOrObj, description);
    notification.error({
        message,
        description: desc
    });
}

function warning(messageOrObj = "", description = "") {
    const { message, description: desc } = normalizeArgs(messageOrObj, description);
    notification.warning({
        message,
        description: desc
    });
}

function info(messageOrObj = "", description = "") {
    const { message, description: desc } = normalizeArgs(messageOrObj, description);
    notification.info({
        message,
        description: desc
    });
}

export default notificationService;
